
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreatedReferralCodeDtoFormGroup() {
return new FormGroup({
    referralCode: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(10)]),
    referralLink: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      